module.exports = __webpack_public_path__ + "img/valvulas_y_electrovalvulas.cf1d9f26.jpg";